import { NotInterested, PushPin } from "@mui/icons-material";
import { Tooltip } from "antd";
import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BounceLoader } from "react-spinners";
import { ListItemsSkeleton } from "../../../../../../components/page-skeleton";

const NotesListing = ({
  isLoading,
  data = [],
  selectedNote,
  selectNote,
  sortNotes,
  pinToggleHandler,
  saveLoader,
}) => {
  const pinnedNotes = data.filter((note) => note.pinned);
  const unpinnedNotes = data.filter((note) => !note.pinned);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    // Determine if the source and destination are from the same list or different lists
    const fromPinned = result.source.droppableId === "pinned";
    const toPinned = result.destination.droppableId === "pinned";
    const sourceList = fromPinned ? pinnedNotes : unpinnedNotes;
    const destinationList = toPinned ? pinnedNotes : unpinnedNotes;

    const reorderedNotes = [...pinnedNotes, ...unpinnedNotes];
    const [movedNote] = reorderedNotes.splice(result.source.index, 1);
    reorderedNotes.splice(result.destination.index, 0, movedNote);

    const updatedData = reorderedNotes.map((note, index) => {
      const data = {
        ...note,
        order: index,
      };
      if (note.id === movedNote.id) data["pinned"] = toPinned;
      return data;
    });
    sortNotes(updatedData);
  };

  const pinUnPinNote = (e, note, pinned) => {
    e.stopPropagation();
    const payload = { ...note, pinned };
    pinToggleHandler(payload); // Update pinned status in the backend
  };

  return (
    <div className="notes-listing">
      {isLoading ? (
        <ListItemsSkeleton rows={5} />
      ) : (
        <>
          {data.length > 0 ? (
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <div className="notes-container">
                {/* Pinned Notes */}
                {pinnedNotes.length >= 1 && (
                  <Droppable droppableId="pinned">
                    {(provided) => (
                      <div
                        className="pinned-notes"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        <h3 className="list-title">
                          <PushPin /> Pinned
                        </h3>
                        {pinnedNotes.map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={String(item.id)}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                className={`note-card pinned ${
                                  selectedNote?.id === item.id ? "selected" : ""
                                }`}
                                onClick={() => selectNote(item)}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <Tooltip title="Unpin note">
                                  <button
                                    onClick={(e) =>
                                      pinUnPinNote(e, item, false)
                                    }
                                    className="pin-note"
                                  >
                                    <PushPin />
                                    <span className="unpin" />
                                  </button>
                                </Tooltip>
                                <h4>{item.note_title || "New Note"}</h4>
                                <div className="card-bottom">
                                  <p>{item.created_at}</p>
                                  <p>Created by {item.created_by}</p>
                                  {saveLoader?.includes(item.id) && (
                                    <span className="save-loader">
                                      <BounceLoader color="#605bff" size={12} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                )}
                {/* Unpinned Notes */}
                <Droppable droppableId="unpinned">
                  {(provided) => (
                    <div
                      className="unpinned-notes"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {unpinnedNotes.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={String(item.id)}
                          index={index + pinnedNotes.length}
                        >
                          {(provided) => (
                            <div
                              className={`note-card ${
                                selectedNote?.id === item.id ? "selected" : ""
                              }`}
                              onClick={() => selectNote(item)}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <Tooltip title="Pin note">
                                <button
                                  onClick={(e) => pinUnPinNote(e, item, true)}
                                  className="pin-note"
                                >
                                  <PushPin />
                                </button>
                              </Tooltip>
                              <h4>{item.note_title || "New Note"}</h4>
                              <div className="card-bottom">
                                <p>{item.created_at}</p>
                                <p>Created by {item.created_by}</p>
                                {saveLoader?.includes(item.id) && (
                                  <span className="save-loader">
                                    <BounceLoader color="#605bff" size={12} />
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </DragDropContext>
          ) : (
            <div className="no-data">
              <p>No Notes</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NotesListing;
